import React, { useState, useEffect } from 'react';
import logo from './logo.png';
import whats from './whatsapplogo.png';

import {
  Container, Grid, Box, Card, CardContent, CardHeader,
  Typography, Button, Paper, Stack, Divider, Tooltip, IconButton,
  TextField, MenuItem, Select, InputLabel, FormControl, Dialog, DialogContent,
  DialogActions, Alert
} from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import DownloadIcon from '@mui/icons-material/Download';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const FormularioLote = ({ lote, currencySymbol, moneda, onCancelar, obtenerUrlImagenManzana }) => {
  const idManzana = lote.Manzana;
  const urlImagenManzana = obtenerUrlImagenManzana(idManzana);

  const [isModalManzanaOpen, setIsModalManzanaOpen] = useState(false);
  const [porcentajes, setPorcentajes] = useState([]);
  const [numeroCuotas, setNumeroCuotas] = useState(0);
  const [cuotasCalculadas, setCuotasCalculadas] = useState(false);

  const phoneNumber = '5492920204561';
  const message = 'Hola, me gustaría comprar un lote.';
  const urlEncodedText = encodeURIComponent(message);

  const emprendimiento = 7;
  
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    tipoPago: '',
    importeAnticipo: '',
    numeroCuotas: '',
    montoCuota: '',
    montoReserva: '',
    cuotasCalculadas: '',
    tipoDocumento: '',
    documento: '',
    direccion: '',
    telefono: '',
    moneda
  });

  // helpers
  const precioFmt = (n) =>
    parseFloat(n).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  // carga porcentajes
  useEffect(() => {
    const fetchData = async () => {
      if (moneda == null) return;
      try {
        const response = await fetch(
          `https://propietarios.pueblonuevo.com.ar/backendterrazas/porcentajes`,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ moneda, emprendimiento }),
          }
        );
        if (!response.ok) throw new Error('Error en la respuesta del servidor');
        const data = await response.json();
        setPorcentajes(data);
      } catch (error) {
        console.error('Error al realizar el fetch:', error);
      }
    };
    fetchData();
  }, [moneda]);

  // cambios de formulario
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (name === 'tipoPago') {
      const selected = porcentajes.find((p) => p.Denominacion === value);
      if (selected) {
        setNumeroCuotas(selected.cuotas);
        // preselecciona automáticamente el máximo disponible
        setFormData((prev) => ({
          ...prev,
          numeroCuotas: String(selected.cuotas),
        }));
      }
    }
    setCuotasCalculadas(false);
  };

  useEffect(() => {
    if (formData.tipoPago === 'Contado') {
      setFormData((prev) => ({
        ...prev,
        cuotasCalculadas: false,
        montoCuota: '0.00',
        montoReserva: (lote.Precio * 1) / 100,
      }));
    }
  }, [formData.tipoPago, lote.Precio]);

  // simulador
  const calcularCuotas = () => {
    let precioFinal = lote.Precio;
    let bonificacion = 0;
    let montoCuotaCalculado = 0;
    let porcentajeMinimo = 0;
    let porcentajeBonificacion = 0;
    let anticipo = 0;

    if (formData.tipoPago === 'Anticipo+Cuotas') {
      const cfg = porcentajes.find((p) => p.Denominacion === 'Anticipo+Cuotas') || {};
      porcentajeMinimo = cfg.minimo || 0;
      porcentajeBonificacion = cfg.bonificacion || 0;

      anticipo = parseFloat(formData.importeAnticipo || 0);
      if (anticipo <= 0) return alert('El anticipo debe ser mayor a cero');

      if (anticipo <= (lote.Precio * porcentajeMinimo) / 100) {
        const minFmt = ((lote.Precio * porcentajeMinimo) / 100).toLocaleString('es-AR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
        return alert(`El anticipo debe ser ≥ ${porcentajeMinimo}% (${currencySymbol}${minFmt})`);
      }

      bonificacion = (anticipo * porcentajeBonificacion) / 100;
      precioFinal = lote.Precio - bonificacion - anticipo;
      montoCuotaCalculado = precioFinal / parseInt(formData.numeroCuotas || 1, 10);
    }

    if (formData.tipoPago === 'Contado') {
      const cfg = porcentajes.find((p) => p.Denominacion === 'Contado') || {};
      porcentajeBonificacion = cfg.bonificacion || 0;
      bonificacion = (lote.Precio * porcentajeBonificacion) / 100;
      precioFinal = lote.Precio - bonificacion;
    }

    if (formData.tipoPago === 'CUOTAS - 100% FINANCIADO') {
      const cfg = porcentajes.find((p) => p.Denominacion === 'CUOTAS - 100% FINANCIADO') || {};
      porcentajeBonificacion = cfg.bonificacion || 0;
      bonificacion = (lote.Precio * porcentajeBonificacion) / 100;
      precioFinal = lote.Precio - bonificacion;
      montoCuotaCalculado = precioFinal / parseInt(formData.numeroCuotas || 1, 10);
    }

    if (formData.tipoPago === '70/30') {
      const cfg = porcentajes.find((p) => p.Denominacion === '70/30') || {};
      porcentajeMinimo = cfg.minimo || 0;
      porcentajeBonificacion = cfg.bonificacion || 0;
      anticipo = (lote.Precio * porcentajeMinimo) / 100;

      if (anticipo < (lote.Precio * porcentajeMinimo) / 100) {
        const minFmt = ((lote.Precio * porcentajeMinimo) / 100).toLocaleString('es-AR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
        return alert(`El anticipo debe ser ≥ ${porcentajeMinimo}% (${currencySymbol}${minFmt})`);
      }

      bonificacion = (lote.Precio * porcentajeBonificacion) / 100;
      precioFinal = lote.Precio - bonificacion - anticipo;
      montoCuotaCalculado = precioFinal / parseInt(formData.numeroCuotas || 1, 10);
    }

    setCuotasCalculadas(true);
    setFormData((prev) => ({
      ...prev,
      anticipo,
      porcentajeMinimo,
      porcentajeBonificacion,
      bonificacion,
      precioFinal,
      montoCuota: montoCuotaCalculado.toFixed(2),
      montoReserva: (lote.Precio * 1) / 100,
      cuotasCalculadas: formData.numeroCuotas,
      montoCuotaCalculado,
      moneda,
    }));
  };

  // envío
  const enviarReserva = async () => {
    const url = 'https://propietarios.pueblonuevo.com.ar/backendterrazas/grabaReserva';
    const datosReserva = {
      nombre: formData.nombre,
      nroDoc: formData.documento,
      tipoDocumento: formData.tipoDocumento,
      direccion: formData.direccion,
      telCelu: formData.telefono,
      email: formData.email,
      emprendimiento:7,
      lote,
      moneda,
    };

    for (const [key, value] of Object.entries(datosReserva)) {
      if (!value) {
        if (key === 'moneda') {
          alert('Por favor, vuelva a la página de inicio y seleccione el lote nuevamente.');
        } else {
          const fieldNames = {
            nombre: 'Nombre',
            nroDoc: 'Documento',
            tipoDocumento: 'Tipo de Documento',
            direccion: 'Dirección',
            telCelu: 'Teléfono',
            email: 'Email',
            lote: 'Lote',
            moneda: 'Moneda',
            emprendimiento: 'Emprendimiento',
          };
          alert(`Falta completar el campo: ${fieldNames[key]}`);
        }
        return;
      }
    }

    try {
      const respuesta = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(datosReserva),
      });
      const resultado = await respuesta.json();
      if (resultado.error) {
        alert('Reserva no realizada: ' + resultado.error + ' Intenta con otro lote!.');
      } else {
        alert('Reserva enviada con éxito. En minutos recibís el cupón de pago en tu correo.');
        onCancelar();
      }
    } catch (error) {
      console.error('Error al enviar la reserva:', error);
      alert('Error al enviar la reserva. Probá de nuevo.');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.nombre.trim() || !formData.email.trim() || !formData.documento.trim() || !formData.direccion.trim() || !formData.telefono.trim()) {
      alert('Por favor, completa todos los campos obligatorios.');
      return;
    }
    const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!regexEmail.test(formData.email)) {
      alert('Por favor, introduce un email válido.');
      return;
    }
    await enviarReserva();
  };

  return (
    <Container
      maxWidth="xl"
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
       
      }}
    >
      {/* Header simple: logo + WhatsApp */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: { xs: 'center', md: 'center' },
          justifyContent: { xs: 'center', md: 'space-between' },
          gap: { xs: 2, md: 0 },
          p: 2,
          width: '100%',
          borderRadius: '15px',
          boxShadow: '-4px 4px 10px rgba(0, 0, 0, 0.1)',
        }}
      >
        <img src={logo} alt="Logo La Pampita" style={{ width: 220, height: 'auto', display: 'block' }} />

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Button
            href={`https://wa.me/${phoneNumber}?text=${urlEncodedText}`}
            target="_blank"
            rel="noopener noreferrer"
            startIcon={<WhatsAppIcon />}
            variant="contained"
            sx={{ background: 'linear-gradient(90deg,#25D366,#128C7E)' }}
          >
            WhatsApp
          </Button>
          <Typography variant="body2">Cel: +54 9 2920 204561</Typography>
        </Box>
      </Box>

      <Box sx={{ width: '100%', p: 2 }}>
        <Grid container spacing={3}>
          {/* Columna 1: resumen + plano */}
          <Grid item xs={12} md={4}>
            <Card elevation={3} sx={{ borderRadius: 3 }}>
              <CardHeader
                title={`Manzana ${idManzana} · Lote ${lote.Lote}`}
                subheader={`Superficie ${lote.Superficie} m²`}
              />
              <CardContent>
                <Alert severity="success" sx={{ mb: 2, borderRadius: 2 }}>
                  Precio {currencySymbol} {precioFmt(lote.Precio)}
                </Alert>

                <Paper variant="outlined" sx={{ p: 1, borderRadius: 2, textAlign: 'center' }}>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      mb: 0.5,
                      px: 1,
                    }}
                  >
                    <Typography variant="subtitle2">Plano técnico</Typography>
                    <IconButton
                      size="small"
                      component="a"
                      href={urlImagenManzana}
                      download={`Manzana_${idManzana}.jpg`}
                      rel="noopener noreferrer"
                    >
                      <DownloadIcon />
                    </IconButton>
                  </Box>

                  <Box
                    onClick={() => setIsModalManzanaOpen(true)}
                    sx={{
                      cursor: 'zoom-in',
                      overflow: 'hidden',
                      borderRadius: 2,
                      boxShadow: 1,
                      p: 0,
                    }}
                  >
                    <img
                      src={urlImagenManzana}
                      alt={`Manzana ${idManzana}`}
                      style={{
                        display: 'block',
                        width: '100%',
                        height: 'auto',
                        maxHeight: '320px',  // límite sutil para que no deje “aire”
                        objectFit: 'contain',
                        margin: 0,
                      }}
                    />
                  </Box>
                </Paper>
              </CardContent>
            </Card>
          </Grid>

          {/* Columna 2: simulador */}
          <Grid item xs={12} md={4}>
            <Card elevation={3} sx={{ borderRadius: 3 }}>
              <CardHeader title="Simulá tu plan de pago" />
              <CardContent>
                <Stack spacing={2}>
                  <FormControl fullWidth>
                    <InputLabel>Forma de pago</InputLabel>
                    <Select
                      label="Forma de pago"
                      name="tipoPago"
                      value={formData.tipoPago}
                      onChange={handleChange}
                    >
                      {porcentajes.map((p) => (
                        <MenuItem key={p.id} value={p.Denominacion}>
                          {p.Denominacion} {p.bonificacion > 0 ? `(${p.bonificacion}%)` : ''}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  {formData.tipoPago === 'Anticipo+Cuotas' && (
                    <TextField
                      name="importeAnticipo"
                      label="Importe Anticipo"
                      value={formData.importeAnticipo}
                      onChange={handleChange}
                      type="number"
                      fullWidth
                      inputProps={{ min: 0, step: '0.01' }}
                    />
                  )}

                  {(formData.tipoPago === 'Anticipo+Cuotas' ||
                    formData.tipoPago === 'CUOTAS - 100% FINANCIADO' ||
                    formData.tipoPago === '70/30') && (
                    <FormControl fullWidth>
                      <InputLabel>Cantidad de cuotas</InputLabel>
                      <Select
                        name="numeroCuotas"
                        value={formData.numeroCuotas}
                        label="Cantidad de cuotas"
                        onChange={handleChange}
                        displayEmpty
                      >
                        <MenuItem value="">
                          <em>Seleccione cantidad de cuotas</em>
                        </MenuItem>
                        {[...Array(numeroCuotas).keys()].map((n) => (
                          <MenuItem key={n + 1} value={n + 1}>
                            {n + 1}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}

                  <Button variant="contained" onClick={calcularCuotas}>
                    Simular plan de pago
                  </Button>

                  {cuotasCalculadas && (
                    <Paper sx={{ p: 2, borderRadius: 2 }} variant="outlined">
                      <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                        Detalles del plan
                      </Typography>
                      <Divider sx={{ mb: 1 }} />
                      <Grid container spacing={1}>
                        <Grid item xs={6}>
                          <Typography variant="body2">
                            <strong>Cuotas:</strong>{' '}
                            {formData.tipoPago !== 'Contado' ? formData.cuotasCalculadas : 'N/A'}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="body2">
                            <strong>Monto por cuota:</strong>{' '}
                            {formData.tipoPago !== 'Contado'
                              ? `${currencySymbol} ${precioFmt(formData.montoCuota)}`
                              : 'N/A'}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="body2">
                            <strong>Bonificación:</strong> {formData.porcentajeBonificacion}% · $
                            {precioFmt(formData.bonificacion || 0)}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="body2">
                            <strong>Precio final:</strong> {currencySymbol}{' '}
                            {precioFmt((formData.precioFinal || 0) + (formData.anticipo || 0))}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Paper>
                  )}
                </Stack>
              </CardContent>
            </Card>
          </Grid>

          {/* Columna 3: datos del contacto (MUI puro) */}
          <Grid item xs={12} md={4}>
            <Card elevation={3} sx={{ borderRadius: 3 }}>
              <CardHeader title="Ingrese sus datos" />
              <CardContent>
                <Box component="form" onSubmit={handleSubmit}>
                  <Stack spacing={1.5}>
                    <TextField
                      label="Nombre completo"
                      name="nombre"
                      value={formData.nombre}
                      onChange={handleChange}
                      fullWidth
                      required
                    />

                    <FormControl fullWidth required>
                      <InputLabel>Tipo de Documento</InputLabel>
                      <Select
                        name="tipoDocumento"
                        label="Tipo de Documento"
                        value={formData.tipoDocumento}
                        onChange={handleChange}
                      >
                        <MenuItem value="DNI">DNI</MenuItem>
                        <MenuItem value="CDI">CDI</MenuItem>
                        <MenuItem value="Pasaporte">Pasaporte</MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      label="Número de Documento"
                      name="documento"
                      value={formData.documento}
                      onChange={handleChange}
                      fullWidth
                      required
                    />

                    <TextField
                      label="Dirección"
                      name="direccion"
                      value={formData.direccion}
                      onChange={handleChange}
                      fullWidth
                      required
                    />

                    <TextField
                      label="Teléfono"
                      name="telefono"
                      value={formData.telefono}
                      onChange={handleChange}
                      fullWidth
                      required
                    />

                    <TextField
                      type="email"
                      label="Email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      fullWidth
                      required
                    />

                    <Stack direction="row" spacing={2} sx={{ pt: 1 }}>
                      <Button
                        type="submit"
                        variant="contained"
                        sx={{
                          flex: 1,
                          background: 'linear-gradient(90deg,#2e7d32,#43a047)',
                          '&:hover': { background: 'linear-gradient(90deg,#1b5e20,#2e7d32)' },
                        }}
                      >
                        RESERVAR
                      </Button>

                      <Button
                        variant="outlined"
                        onClick={onCancelar}
                        startIcon={<HomeIcon />}
                        sx={{ flex: 1 }}
                      >
                        Ver otro lote
                      </Button>
                    </Stack>
                  </Stack>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>

      {/* Dialog del plano */}
      <Dialog
        open={isModalManzanaOpen}
        onClose={() => setIsModalManzanaOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogContent dividers sx={{ p: 0 }}>
          <img
            src={urlImagenManzana}
            alt={`Plano M${idManzana}`}
            style={{ width: '100%', display: 'block' }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsModalManzanaOpen(false)}>Cerrar</Button>
          <Button
            component="a"
            href={urlImagenManzana}
            download={`Manzana_${idManzana}.jpg`}
            startIcon={<DownloadIcon />}
          >
            Descargar
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

FormularioLote.displayName = 'FormularioLote';
export default FormularioLote;
